import script from "./UserQuestionMyList.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserQuestionMyList.vue?vue&type=script&setup=true&lang=ts"

import "./UserQuestionMyList.vue?vue&type=style&index=0&id=53876f6e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53876f6e"]])

export default __exports__